import { cx } from '@linaria/core';
import { Chevron } from '@utils/react';
import { sortableColumnHeaderChevron, sortableColumnHeader, columnHeader } from './column.style.js';
import { jsx, jsxs } from 'react/jsx-runtime';

function SortableColumnHeading(props) {
  return /*#__PURE__*/jsx("button", {
    role: "columnheader",
    className: cx(sortableColumnHeader, props.active && "active"),
    onClick: props.onSort,
    "aria-label": `Sortér efter ${props.children} ${props.direction === "asc" ? "stigende" : "faldende"}`,
    children: /*#__PURE__*/jsxs("div", {
      children: [/*#__PURE__*/jsx("span", {
        children: props.children
      }), /*#__PURE__*/jsx(Chevron, {
        className: sortableColumnHeaderChevron,
        size: 8,
        lineWidth: 1,
        vertical: true,
        inversed: props.active && props.direction === "asc"
      })]
    })
  });
}
function ColumnHeading(props) {
  return /*#__PURE__*/jsx("span", {
    role: "columnheader",
    "aria-label": "label" in props ? props.label : undefined,
    className: cx(columnHeader, "className" in props ? props.className : undefined),
    children: "children" in props ? props.children : undefined
  });
}

export { ColumnHeading, SortableColumnHeading };
//# sourceMappingURL=column.js.map
